<div>
  <div class="report-tab">
    <ul class="nav nav-pills" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" #storeTab
          type="button" role="tab" aria-controls="pills-home" aria-selected="true" (click)="topPerformerTabChange(0)">
          Stores
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile"
          type="button" role="tab" aria-controls="pills-profile" aria-selected="false"
          (click)="topPerformerTabChange(1)">
          Employees
        </button>
      </li>
    </ul>
  </div>

  <div class="d-flex nav-dropdowns mt-3">
    <select class="form-select" [(ngModel)]="deptID">
      <option selected value="0">All Departments</option>
      <option *ngFor="let dept of mainDepartmentList" [ngValue]="dept.departmentId">
        {{ dept.departmentDescr }}
      </option>
    </select>

    <select class="form-select me-3" [(ngModel)]="isItemEntry">
      <option>Select Entry</option>
      <option [ngValue]="false">Item Entry</option>
      <option [ngValue]="true">Value of item</option>
    </select>

    <select class="form-select me-3" *ngIf="isTableData" [(ngModel)]="periodId" (change)="selectPeriod()">
      <option [ngValue]="1">Daily</option>
      <option [ngValue]="2" *ngIf="showWeeklyOption">Weekly</option>
      <option [ngValue]="3">Monthly</option>
    </select>

    <select class="form-select me-3" *ngIf="isTableData" (change)="formateDate($event)">
      <ng-container *ngFor="let item of periodDayArray; let i = index">
        <option *ngIf="periodId == 1" [value]="i">{{ item.name }}</option>
      </ng-container>
      <ng-container *ngFor="let item of periodArray; let i = index">
        <option *ngIf="periodId == 3" [value]="i">{{ item.name }}</option>
      </ng-container>
      <ng-container *ngFor="let item of weekData; let i = index">
        <option *ngIf="periodId == 2 && showWeeklyOption" [value]="i">{{ item.colorName }}</option>
      </ng-container>
    </select>

    <div class="create-btn run-report-btn ms-2 c-pt" [class.is-loading]="isLoading" (click)="runReport()">
      <span class="run-spinner" *ngIf="isLoading"></span>
      <img *ngIf="!isLoading" src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
      {{ isLoading ? "Running…" : "Run Report" }}
    </div>

    <div class="d-flex form-control ms-2" style="width: 6rem; cursor: pointer; height: fit-content">
      <img class="me-3" [src]="
          isTableData
            ? 'assets/dashboard/menu1Active.svg'
            : 'assets/dashboard/menu.svg'
        " (click)="toggleTableOrGraph(true)" matTooltip="Top Performers" matTooltipPosition="above"
        matTooltipClass="raised-tooltip" />
      <img [src]="
          isTableData
            ? 'assets/dashboard/menu2Active.svg'
            : 'assets/dashboard/menu2.svg'
        " (click)="toggleTableOrGraph(false)" matTooltip="Daily Top Performer" matTooltipPosition="above"
        matTooltipClass="raised-tooltip" />
    </div>
  </div>
</div>

<!-- empty state: shown until the report is run -->
<div class="report-empty-state" *ngIf="!reportHasRun">
  <img src="assets/dashboard/noData.svg" alt="" />
  <h5>Ready when you are</h5>
  <p>
    Choose your department, period and view above, then click
    <strong>Run Report</strong> to see your top performers.
  </p>
  <div class="create-btn run-report-btn c-pt" (click)="runReport()">
    <img src="assets/Pos-Catalog/jam_refresh.svg" class="run-icon" alt="" />
    Run Report
  </div>
</div>

<section class="performance-tbl-container mb-0" *ngIf="isTableData && reportHasRun">
  <div class="tab-content" id="pills-tabContent">
    <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab"
      tabindex="0">
      <table class="table tbl-store" *ngIf="performerData2.length > 0">
        <thead class="tbl-heads sticky-top mb-0">
          <tr>
            <th class="text-end text-trasnform" style="width: 10%; padding-right: 6rem">
              Rank &nbsp;<img src="assets/dashboard/arrowUpDown.svg" />
            </th>
            <th style="width: 10%" class="text-trasnform">Store Name</th>
            <th class="text-end text-trasnform" style="width: 40%">
              Total Value of Item
            </th>
            <th class="text-end text-trasnform" style="width: 40%; padding-right: 3rem">
              Total Item Entry &nbsp;
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of performerData2">
            <td class="rank-column" style="font-size: 14px; font-weight: 700">
              {{ item.rank }}
              <div class="ms-2">
                <span *ngIf="item.position > 0" style="color: #1cbb2c"><img
                    src="assets/onboarding/ic_rankUp.svg" /><small>{{
                    item.position
                    }}</small>
                </span>
                <span *ngIf="item.position < 0" style="color: #eb1e1e"><img
                    src="assets/onboarding/ic_rankDown.svg" /><small>{{
                    -item.position
                    }}</small>
                </span>
                <span *ngIf="item.position === 0">--</span>
              </div>
            </td>

            <td style="font-size: 14px; font-weight: 700">
              {{ item.storeName }}
            </td>

            <td class="text-end" [style.font-weight]="isItemEntry ? '700' : ''">
              {{ item.totalPrice | currency }}
            </td>
            <td class="text-end" [style.font-weight]="isItemEntry ? '' : '700'" style="padding-right: 3rem">
              {{ item.totalItems }}
            </td>
          </tr>
        </tbody>
      </table>
      <!--No table data-->
      <div class="no-table-report text-center" *ngIf="performerData2.length == 0">
        <div class="m-auto">
          <div class="img-container m-auto d-flex">
            <img src="assets/emp reports/ic_noTableData.svg" class="m-auto" />
          </div>

          <p style="color: #9e9e9e" class="mt-4">
            There is no top performers available yet. <br />
            Please check back later
          </p>
        </div>
      </div>
    </div>
    <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
      <table class="table tbl-employee mb-0" *ngIf="performerData.length > 0">
        <thead class="tbl-heads sticky-top">
          <tr>
            <th class="text-end" style="width: 10%; padding-right: 6rem">
              Rank &nbsp;<img src="assets/dashboard/arrowUpDown.svg" />
            </th>
            <th style="width: 10%">Employee Name</th>

            <th class="text-end" style="width: 40%">Total Value of Item</th>
            <th class="text-end" style="width: 40%; padding-right: 3rem">
              Total Item Entry &nbsp;
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of performerData">
            <td class="rank-column">
              {{ item.rank }}
              <div class="ms-2">
                <span *ngIf="item.position > 0" style="color: #1cbb2c"><img
                    src="assets/onboarding/ic_rankUp.svg" /><small>{{
                    item.position
                    }}</small>
                </span>
                <span *ngIf="item.position < 0" style="color: #eb1e1e"><img
                    src="assets/onboarding/ic_rankDown.svg" /><small>{{
                    -item.position
                    }}</small>
                </span>
                <span *ngIf="item.position == 0">--</span>
              </div>
            </td>
            <td>
              <img [src]="item.profileFileUrl || 'assets/dashboard/default_performer.png'" class="profile-img-table"
                onerror="this.src='assets/dashboard/default_performer.png'" />
              {{ item.userName }}
            </td>

            <td class="text-end" [style.font-weight]="isItemEntry ? '700' : ''">
              {{ item.totalPrice | currency }}
            </td>
            <td class="text-end" [style.font-weight]="isItemEntry ? '' : '700'" style="padding-right: 3rem">
              {{ item.totalItems }}
            </td>
          </tr>
        </tbody>
      </table>
      <!--No table data-->
      <div class="no-table-report text-center" *ngIf="performerData.length == 0">
        <div class="m-auto">
          <div class="img-container m-auto d-flex">
            <img src="assets/emp reports/ic_noTableData.svg" class="m-auto" />
          </div>

          <p style="color: #9e9e9e" class="mt-4">
            There is no top performers available yet. <br />
            Please check back later
          </p>
        </div>
      </div>
    </div>
  </div>

  <!--loader-->
  <div class="overlay" *ngIf="isLoading">
    <div class="loader"></div>
  </div>
</section>

<section *ngIf="!isTableData && !empCardPerformer && reportHasRun" class="performer-card emp-card">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between performer-head">
        <p>Daily Top Performer</p>
        <select class="form-select" style="width: 15rem" (change)="formateCardDetailDates($event, 1)">
          <option *ngFor="let item of periodDayArray; let i = index" [value]="i">
            {{ item.name }}
          </option>
        </select>
      </div>

      <div class="card mt-2">
        <div class="card-body">
          <div class="row" *ngIf="performanceEmpDaily.length">
            <div class="col-4 text-center d-flex flex-column align-items-center"
              *ngFor="let item of performanceEmpDaily">
              <img [src]="item.img" class="performer-photo-card"
                onerror="this.src='assets/dashboard/default_performer.png'" />
              <div class="performer-title">
                <img [src]="item.icRank" style="width: 350px" />
                <div class="performer-title-fg">
                  <p>{{ item.userName }}</p>
                  <span *ngIf="isItemEntry === false">{{ item.totalItems | number }} Items Entry</span>
                  <span *ngIf="isItemEntry === true" class="ps-3">{{ item.totalPrice | currency }} Value of Item</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row h-100" *ngIf="performanceEmpDaily.length === 0">
            <div class="col-12 d-flex flex-column justify-content-center text-center">
              <img src="assets/dashboard/noData.svg" style="height: 145px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5" *ngIf="showWeeklyOption">
    <div class="col-12">
      <div class="d-flex justify-content-between performer-head">
        <p>Weekly Top Performer</p>
        <select class="form-select" style="width: 15rem" (change)="formateCardDetailDates($event, 2)">
          <option *ngFor="let item of weekData; let i = index" [value]="i">
            {{ item.colorName }}
          </option>
        </select>
      </div>

      <div class="card mt-2">
        <div class="card-body">
          <div class="row" *ngIf="performanceEmpWeekly.length">
            <div class="col-4 text-center d-flex flex-column align-items-center"
              *ngFor="let item of performanceEmpWeekly">
              <img [src]="item.img" class="performer-photo-card"
                onerror="this.src='assets/dashboard/default_performer.png'" />
              <div class="performer-title">
                <img [src]="item.icRank" style="width: 350px" />
                <div class="performer-title-fg">
                  <p>{{ item.userName }}</p>
                  <span *ngIf="isItemEntry === false">{{ item.totalItems }} Items Entry</span>
                  <span *ngIf="isItemEntry === true" class="ps-3">{{ item.totalPrice | currency }} Value of Item</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row h-100" *ngIf="performanceEmpWeekly.length === 0">
            <div class="col-12 d-flex flex-column justify-content-center text-center">
              <img src="assets/dashboard/noData.svg" style="height: 145px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12">
      <div class="d-flex justify-content-between performer-head">
        <p>Monthly Top Performer</p>
        <select class="form-select" style="width: 15rem" (change)="formateCardDetailDates($event, 3)">
          <option *ngFor="let item of periodArray; let i = index" [value]="i">
            {{ item.name }}
          </option>
        </select>
      </div>

      <div class="card mt-2">
        <div class="card-body">
          <div class="row" *ngIf="performanceEmpMonthly.length">
            <div class="col-4 text-center d-flex flex-column align-items-center"
              *ngFor="let item of performanceEmpMonthly">
              <img [src]="item.img" class="performer-photo-card"
                onerror="this.src='assets/dashboard/default_performer.png'" />
              <div class="performer-title">
                <img [src]="item.icRank" style="width: 350px" />
                <div class="performer-title-fg">
                  <p>{{ item.userName }}</p>
                  <span *ngIf="isItemEntry === false">{{ item.totalItems }} Items Entry</span>
                  <span *ngIf="isItemEntry === true" class="ps-3">{{ item.totalPrice | currency }} Value of Item</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row h-100" *ngIf="performanceEmpMonthly.length === 0">
            <div class="col-12 d-flex flex-column justify-content-center text-center">
              <img src="assets/dashboard/noData.svg" style="height: 145px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="!isTableData && empCardPerformer && reportHasRun" class="performer-card store-card">
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-between performer-head">
        <p>Daily Top Performer</p>
        <select class="form-select" style="width: 15rem" (change)="formateCardDetailDates($event, 1)">
          <option *ngFor="let item of periodDayArray; let i = index" [value]="i">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="card mt-2">
        <div class="card-body">
          <div class="row" *ngIf="performanceCardDaily.length">
            <div class="col-4 text-center" *ngFor="let item of performanceCardDaily">
              <img [src]="item.img" />
              <div class="performer-title">
                <img [src]="item.icRank" style="width: 350px" />
                <div class="performer-title-fg">
                  <p>{{ item.storeName }}</p>
                  <span *ngIf="isItemEntry === false">{{ item.totalItems }} Items Entry</span>
                  <span *ngIf="isItemEntry === true" class="ps-3">{{ item.totalPrice | currency }} Value of Item</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row h-100" *ngIf="performanceCardDaily.length === 0">
            <div class="col-12 d-flex flex-column justify-content-center text-center">
              <img src="assets/dashboard/noData.svg" style="height: 145px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5" *ngIf="showWeeklyOption">
    <div class="col-12">
      <div class="d-flex justify-content-between performer-head">
        <p>Weekly Top Performer</p>
        <select class="form-select" style="width: 15rem" (change)="formateCardDetailDates($event, 2)">
          <option *ngFor="let item of weekData; let i = index" [value]="i">
            {{ item.colorName }}
          </option>
        </select>
      </div>

      <div class="card mt-2">
        <div class="card-body">
          <div class="row" *ngIf="performanceCardWeekly.length">
            <div class="col-4 text-center" *ngFor="let item of performanceCardWeekly">
              <img [src]="item.img" />
              <div class="performer-title">
                <img [src]="item.icRank" style="width: 350px" />
                <div class="performer-title-fg">
                  <p>{{ item.storeName }}</p>
                  <span *ngIf="isItemEntry === false">{{ item.totalItems }} Items Entry</span>
                  <span *ngIf="isItemEntry === true" class="ps-3">{{ item.totalPrice | currency }} Value of Item</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row h-100" *ngIf="performanceCardWeekly.length === 0">
            <div class="col-12 d-flex flex-column justify-content-center text-center">
              <img src="assets/dashboard/noData.svg" style="height: 145px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12">
      <div class="d-flex justify-content-between performer-head">
        <p>Monthly Top Performer</p>
        <select class="form-select" style="width: 15rem" (change)="formateCardDetailDates($event, 3)">
          <option *ngFor="let item of periodArray; let i = index" [value]="i">
            {{ item.name }}
          </option>
        </select>
      </div>

      <div class="card mt-2">
        <div class="card-body">
          <div class="row" *ngIf="performanceCardMonthly.length">
            <div class="col-4 text-center" *ngFor="let item of performanceCardMonthly">
              <img [src]="item.img" />
              <div class="performer-title">
                <img [src]="item.icRank" style="width: 350px" />
                <div class="performer-title-fg">
                  <p>{{ item.storeName }}</p>
                  <span *ngIf="isItemEntry === false">{{ item.totalItems }} Items Entry</span>
                  <span *ngIf="isItemEntry === true" class="ps-3">{{ item.totalPrice | currency }} Value of Item</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row h-100" *ngIf="performanceCardMonthly.length === 0">
            <div class="col-12 d-flex flex-column justify-content-center text-center">
              <img src="assets/dashboard/noData.svg" style="height: 145px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
